import type { AlertBanner } from '~/modules/common/alerter/alert-banner';

const alerts: AlertBanner[] = [];

/** Defines the application alerts and their display conditions. */
export const alertsConfig = alerts;
